/* assets/basket-delivery.js -- keep the basket's delivery date and its
   "£X away from free next day delivery" line right after the drawer
   redraws (Alan, 2026-09-29: "start work on the basket delivery dates /
   x to free").

   snippets/basket-delivery.liquid computes both on the server, from the one
   dispatch rule (snippets/dispatch-days.liquid). When theme.js redraws the
   drawer it fires "ostrich:cart-rendered"; this re-fetches the /cart
   section, copies the fresh block's date attributes and progress line
   across, and fires "ostrich:delivery-refresh" so theme.js's
   initDeliveryDates draws the date from the live clock. No date arithmetic
   and no dispatch table live here. */
(function () {
  "use strict";

  var COPY_ATTRS = ["data-dispatch-days", "data-transit-min", "data-transit-max", "data-tier", "data-cutoff-hour", "data-fallback"];

  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-basket-delivery]"));
  }

  function applyDate(live, fresh) {
    if (!live || !fresh) return;
    COPY_ATTRS.forEach(function (attr) {
      var v = fresh.getAttribute(attr);
      if (v === null) live.removeAttribute(attr);
      else live.setAttribute(attr, v);
    });
  }

  function applyProgress(container, fresh) {
    var live = container.querySelector("[data-basket-progress]");
    if (fresh) {
      var clone = fresh.cloneNode(true);
      if (live) live.replaceWith(clone);
      else container.appendChild(clone);
    } else if (live) {
      live.remove();
    }
  }

  var inFlight = null;
  function refresh() {
    var els = blocks();
    if (!els.length) return;
    var cartUrl = els[0].getAttribute("data-cart-url") || "/cart";
    var token = {};
    inFlight = token;
    fetch(cartUrl + "?section_id=basket-delivery", { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("basket section " + res.status);
        return res.text();
      })
      .then(function (html) {
        if (inFlight !== token) return; // a newer redraw has started; its answer wins
        var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-basket-delivery]");
        if (!fresh) return;
        var freshDate = fresh.querySelector("[data-delivery-date]");
        var freshProgress = fresh.querySelector("[data-basket-progress]");
        els.forEach(function (el) {
          applyDate(el.querySelector("[data-delivery-date]"), freshDate);
          applyProgress(el, freshProgress);
        });
        document.dispatchEvent(new CustomEvent("ostrich:delivery-refresh"));
      })
      .catch(function () {
        // On a failed fetch the block keeps its last good state rather than
        // blanking; the next redraw tries again.
      });
  }

  document.addEventListener("ostrich:cart-rendered", refresh);
})();
